import { useShopsQuery } from '@/api/app/queries/shops.generated';
import { client } from '@/api/gatewayClient';
import useNotification from '@/composables/useNotification';
import useShopStore from '@/stores/shop';
import type { ComputedRef, Ref } from 'vue';
import { computed } from 'vue';

export const useShopQuery = ({
  shopID,
  shopHandle,
}: {
  shopID?: ComputedRef<string | undefined> | Ref<string>;
  shopHandle?: string;
}) => {
  const shopStore = useShopStore();
  const { handleByStatus, handleError } = useNotification();
  if (shopHandle == 'unknown') {
    handleByStatus(401, 401999, 'Shop not found');
    return;
  }
  const { data } = useShopsQuery(
    reactive({
      first: 1,
      where: {
        id: shopID,
        handle: shopHandle,
      },
    }),
    {
      onSuccess: (result) => {
        const shop = result.shops?.edges?.[0]?.node;
        if (shop) {
          shopStore.setShop(shop);
          client.setHeader('X-GemX-Shop-ID', shop.id);
        } else {
          handleByStatus(401, 401999, new Error('Shop not found'));
        }
      },
      onError: handleError,
      enabled: !!shopHandle || computed(() => !!shopID?.value && shopID?.value !== '0'),
      cacheTime: 0, // force cacheTime=0 because multi layout(instant shop not null, welcome instant shop is null)
    },
  );

  return computed(() => data.value?.shops?.edges?.[0]?.node);
};
